<template>
  <v-layout id="contentNoticesNotAuthModal" row wrap style="max-height: 65vh;" class="scrollDesign">
    <v-flex xs12>
      <v-list two-line subheader>
        <v-slide-y-transition group>
          <v-subheader key="subheader">Comunicados pendientes por confirmar</v-subheader>
          <v-list-tile
            avatar
            class="pa-2 mb-3 buttonLeft elementVisor"
            v-if="notices.length == 0 && !working.loading"
            key="NO NOTICES"
          >
            <v-list-tile-avatar>
              <v-avatar>
                <v-icon color="green">check_circle</v-icon>
              </v-avatar>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>No tienes comunicados</v-list-tile-title>
              <v-list-tile-sub-title>pendientes por autorizar</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            avatar
            class="pa-2 mb-3 elevation-1 grey lighten-5 buttonLeft elementVisor"
            style="padding:0px !important;"
            v-for="notice in notices"
            :key="notice.id"
          >
            <v-list-tile-avatar>
              <v-avatar
                style="top: 2px; left:4 px;"
                :size="70"
                @click="$emit('watchNotice', notice)"
              >
                <v-img
                  v-if="notice.img != null && notice.img != ''"
                  :src="'data:image/jpg;base64, ' + notice.img"
                ></v-img>
                <v-img
                  v-else-if="notice.type == 'A'"
                  :src="require('@/assets/notices/SKLB-Aviso 3.png')"
                ></v-img>
                <v-img
                  v-else-if="notice.type == 'E'"
                  :src="require('@/assets/notices/SKLB-Evento.png')"
                ></v-img>
                <v-img
                  v-else-if="notice.type == 'R'"
                  :src="require('@/assets/notices/SKLB-informe.png')"
                ></v-img>
                <v-img
                  v-else-if="notice.type == 'P'"
                  :src="require('@/assets/notices/SKLB-Permiso.png')"
                ></v-img>
              </v-avatar>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="text-truncate" v-text="notice.title"></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action class="text-xs-left">
              <v-edit-dialog
                class="mr-3"
                :return-value.sync="description"
                lazy
                small
                @save="desitionNotice(notice, false, description)"
                @cancel="description = ''"
                @close="description = ''"
                save-text="Aceptar"
                cancel-text="Cancelar"
              >
                <v-tooltip bottom>
                  <v-btn icon slot="activator">
                    <v-icon color="red">cancel</v-icon>
                  </v-btn>
                  <span>Cancelar comunicado</span>
                </v-tooltip>
                <template v-slot:input>
                  <v-text-field v-model="description" label="Motivo"></v-text-field>
                </template>
              </v-edit-dialog>

              <v-tooltip bottom class="mr-3">
                <v-btn @click="desitionNotice(notice, true)" icon slot="activator">
                  <v-icon color="green">check_circle</v-icon>
                </v-btn>
                <span>Confirmar comunicado</span>
              </v-tooltip>
            </v-list-tile-action>
          </v-list-tile>
        </v-slide-y-transition>
        <v-progress-circular v-show="working.loading" indeterminate color="primary"></v-progress-circular>
      </v-list>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data: () => ({
    totalNotices: 0,
    notices: [],
    filters: {
      size: 8,
      offset: 0
    },
    working: {
      loading: false
    },
    description: ""
  }),
  mounted() {
    this.getNotices();
    document
      .getElementById("contentNoticesNotAuthModal")
      .addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    document
      .getElementById("contentNoticesNotAuthModal")
      .removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      var event = document.getElementById("contentNoticesNotAuthModal");
      if (
        event.offsetHeight + event.scrollTop == event.scrollHeight &&
        !this.working.loading
      ) {
        if (this.notices.length < this.totalNotices) {
          this.filters.offset++;
          this.getNotices();
        }
      }
    },
    getNoticeImage(notice) {
      this.$store
        .dispatch("notice/getImage", notice.id)
        .then(response => {
          if (
            response.data.entity.imgs != null &&
            response.data.entity.imgs.length > 0
          ) {
            this.notices[this.notices.indexOf(notice)].img =
              response.data.entity.imgs[0];
            this.notices[this.notices.indexOf(notice)].imgs =
              response.data.entity.imgs;
            this.$forceUpdate();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getNotices() {
      this.working.loading = true;
      this.$store
        .dispatch("notice/getNoticeNotConfirmed", this.filters)
        .then(response => {
          this.notices = this.notices.concat(response.data.entity);
          this.totalNotices = response.data.size;
          this.working.loading = false;
          for (var n in this.notices) {
            this.getNoticeImage(this.notices[n]);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    desitionNotice(notice, flag, description = null) {
      this.$emit("loading", true);
      if (flag) {
        this.$store
          .dispatch("notice/confirmNotice", { 
            notice: notice, 
            target: "A" 
          })
          .then(response => {
            this.$emit("loading", false);
            this.$emit("success");
            this.filters.offset = 0;
            this.notices = [];
            this.$forceUpdate();
            this.getNotices();
          })
          .catch(error => {
            this.$emit("loading", false);
            this.$emit("failed");
            console.log(error);
          });
      } else {
        notice.confirmDescription = description;
        this.$store
          .dispatch("notice/confirmNotice", {
            notice: notice,
            target: "C"
          })
          .then(response => {
            this.$emit("loading", false);
            this.$emit("success");
            this.filters.offset = 0;
            this.notices = [];
            this.$forceUpdate();
            this.getNotices();
          })
          .catch(error => {
            this.$emit("loading", false);
            this.$emit("failed");
            console.log(error);
          });
      }
    }
  }
};
</script>

<style >
</style>